import React from 'react';
import { Props } from './Header.types';
import AppBar from '@mui/material/AppBar';
import TheGuarantorsLogo from '../../assets/images/TheGuarantors_Logo.svg';
import Toolbar from '@mui/material/Toolbar';

export const LearnHeader: React.FC<Props> = () => {
console.log(window.location.href);

return  <AppBar component="nav" sx={{ pr: 0, boxShadow: '4px 16px 32px rgba(0, 0, 0, 0.08)' }}>
<Toolbar sx={{ backgroundColor: 'white', color: 'black', justifyContent:'center' }}>
  {/* Temporary - removal of the hamburger icon for mobile for now  */}
  {/* <IconButton
    aria-label="open drawer"
    edge="start"
    sx={{ mr: 2, display: { sm: 'none' } }}
  >
    <MenuIcon />
  </IconButton> */}
  <img height="30px" alt="" src={TheGuarantorsLogo} />
  </Toolbar>
</AppBar>

};
